export default __webpack_public_path__ + "static/media/homeBannerBgMb.10e1475e.png";